/**
 * Canonical version source for the whole product.
 * package.json version, UI display, changelog and release tags must match this.
 */
export const APP_VERSION = '5.0.0' as const
export const APP_NAME = 'RUST' as const
export const APP_DOMAIN = 'https://www.rust.mobi' as const
